import { HomepageComponent } from './homepage/homepage.component';

export const routes = [
    {
        path: '',
        component: HomepageComponent
    },
]
